/**
 * @desc 获取模型
 */
const URL = "/rantion-activiti";
import http, { updateResponse } from "@/http";
export type Response = defs.activiti.ObjectNode;
export function request(modelId: string | number, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/activiti/model/${modelId}/json`, {
      method: "GET",

      ...options,
    }),
  );
}
